import { render, staticRenderFns } from "./ActiveBidderCampaigns.vue?vue&type=template&id=58f70f41&scoped=true&"
import script from "./ActiveBidderCampaigns.vue?vue&type=script&lang=js&"
export * from "./ActiveBidderCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBidderCampaigns.vue?vue&type=style&index=0&id=58f70f41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f70f41",
  null
  
)

export default component.exports